export const ACCESS_TOKEN_KEY = "_access_token_";
export const REFRESH_TOKEN_KEY = "_refresh_token_";
export const USER_KEY = "_user";
